import {Featured, Gallery} from '../index';
import LocationInfo from './LocationInfo';
import AYCESection from '../AYCESection';

const LocationContent = ({locationInfo, featuredItems, storeCode}) => {
  const images = 'photos' in locationInfo ?
      locationInfo.photos.map((image) => image.url):
  [];

  const menuUrl = `/locations/${storeCode}/menu`;
  return (
    <div id={`location_info`}>
      <LocationInfo locationInfo={locationInfo} />
      {locationInfo.hasAYCE ?
        <AYCESection menuUrl={menuUrl} /> :
            <Featured items={featuredItems}
              menuUrl={menuUrl}/>}
      {images.length > 0 &&
            <Gallery images={images} />}
    </div>
  );
};

export default LocationContent;
